import { Howl, Howler } from 'howler';
import GSObject from '../../Base/GSObject';
import Global from '../../Global';
import Vector from '../../Base/Math/Vector';
import Angle from '../../Base/Math/Angle';
import { ReactionAfterwards } from '../../../GameKit/shared';
import LibraryManager from '../../Base/Library/LibraryManager';

export { ReactionAfterwards };

export default class ActieReactie extends GSObject {
    constructor(gsoParent) {
        super(gsoParent);

        this.blok = gsoParent;

        // I respond when:
        this.respondToPlayerCollision = false;
        this.respondToObjectCollision = false;

        // Then my response is:
        this.points = 0;
        this.health = 0;
        this.sound = ''; // "" or <sound-library-entry-id>
        this.passOnReaction = ''; // "" or <blok-uuid>
        this.toLevel = ''; // "", "next" or <level-uuid>

        // And after that:
        this.afterwards = ReactionAfterwards.StayTheSame;

        // Runtime vars
        this._reacting = false;
        this._reacted = 0;
    }

    react() {
        this._reacting = true;
    }

    _realReact() {
        if (this.points !== 0) {
            window.GamePlayer.instance.modifyPoints(this.points);
        }
        if (this.health !== 0) {
            window.GamePlayer.instance.modifyHealth(this.health);
        }
        if (this.sound !== '') {
            LibraryManager.sounds
                .get(this.sound)
                .get()
                .play();
        }
        if (this.passOnReaction !== '') {
            const result = this.blok.level.blokken.findByUUID(this.passOnReaction);
            if (result) {
                result.getActiveActieReactie().react();
            }
        }
        if (this.toLevel !== '') {
            this.getGame().activeLevel.finish(this.toLevel);
        }

        if (this.afterwards === ReactionAfterwards.ChangeState) {
            this.blok.setActiveState(1);
        } else if (this.afterwards === ReactionAfterwards.Disappear) {
            this.blok.disable();
        }
    }

    onCreateBody(physicsWorld) {}

    onDestroyBody(physicsWorld) {
        this._reacting = false;
        this._reacted = 0;
    }

    onFixedUpdate(deltaTime) {
        if (this._inPlayMode) {
            if (this._reacting && this._reacted === 0) {
                this._realReact();
                this._reacted = 8;
            }
            if (!this._reacting && this._reacted > 0) {
                this._reacted -= 1;
            }
            this._reacting = false;
        }
    }
}

ActieReactie.serializeableFields = {
    respondToPlayerCollision: Boolean,
    respondToObjectCollision: Boolean,
    points: Number,
    health: Number,
    sound: String,
    passOnReaction: String,
    toLevel: String,
    afterwards: Number
};
